import { render } from "./DynamicSearch.vue?vue&type=template&id=7ed840dc&scoped=true"
import script from "./DynamicSearch.vue?vue&type=script&lang=js"
export * from "./DynamicSearch.vue?vue&type=script&lang=js"

import "./DynamicSearch.vue?vue&type=style&index=0&id=7ed840dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed840dc"]])

export default __exports__